import React from 'react';
import PropTypes from 'prop-types';
import {Box, Flex, Image, Text} from "rebass";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import {Divider} from "reakit";
import styled from 'styled-components'

const textProps = {
	ml: 3
};

const ClickWrapper = styled(Flex)`
	-webkit-touch-callout: none; 
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none;
	user-select: none;
	cursor: pointer;
`;

const GradeSelect = props => {
	const {handleSelect, audience} = props;
	return (
		<Flex flexWrap={'wrap'} flexDirection={'column'}>
			<Box width={1}>
				<Divider marginTop={'0'}/>
			</Box>
			<ClickWrapper onClick={() => handleSelect('3', 1)}>
				<Box>
					<Text {...textProps} >3rd Form</Text>
				</Box>
				<Box ml={'auto'}/>
				<Box pr={2}>
					{audience[1].includes('3') && <Image src={check}/>}
				</Box>
			</ClickWrapper>
			<Divider/>
			<ClickWrapper onClick={() => handleSelect('4', 1)}>
				<Box>
					<Text {...textProps} >4th Form</Text>
				</Box>
				<Box ml={'auto'}/>
				<Box pr={2}>
					{audience[1].includes('4') && <Image src={check}/>}
				</Box>
			</ClickWrapper>
			<Divider/>
			<ClickWrapper onClick={() => handleSelect('5', 1)}>
				<Box>
					<Text {...textProps} >5th Form</Text>
				</Box>
				<Box ml={'auto'}/>
				<Box pr={2}>
					{audience[1].includes('5') && <Image src={check}/>}
				</Box>
			</ClickWrapper>
			<Divider/>
			<ClickWrapper onClick={() => handleSelect('6', 1)}>
				<Box>
					<Text {...textProps} >6th Form</Text>
				</Box>
				<Box ml={'auto'}/>
				<Box pr={2}>
					{audience[1].includes('6') && <Image src={check}/>}
				</Box>
			</ClickWrapper>
			<Box width={1}>
				<Divider marginBottom={'0'}/>
			</Box>
		</Flex>
	);
};

GradeSelect.propTypes = {
	handleSelect: PropTypes.func,
	audience: PropTypes.array
};

GradeSelect.defaultProps = {
	handleSelect: (x, y) => console.log('Grade', x),
	audience: [[]]
};

export default GradeSelect;
